import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AdminLayout from "layouts/Admin.js";
import StudentLayout from "layouts/Student.js";
import StaffLayout from "layouts/Stuff";
import PublicResult from "views/public/publicResult";

import AuthLayout from "layouts/Auth.js";

const AppRouter = () => {
  // const role = localStorage.getItem('role');
  const getLayoutAndRoute = (role) => {
    if (localStorage.getItem("token")) {
      // console.log('role ', role)
      switch (role) {
        case "superadmin":
          return { Layout: AdminLayout, route: "/admin/*" };
        case "student":
          return { Layout: StudentLayout, route: "/student/*" };
        case "teacher":
          return { Layout: StaffLayout, route: "/staff/*" };
        default:
          return { Layout: AuthLayout, route: "/auth/*" };
      }
    } else {
      return { Layout: AuthLayout, route: "/auth/*" };
    }
  };

  const { Layout, route } = getLayoutAndRoute(localStorage.getItem("role"));
  // console.log('Layout, route ', Layout, route)
  return (
    <Routes>
      <Route path="/publicResult" element={<PublicResult />} />
      <Route path={route} element={<Layout />} />
      <Route path={"/"} element={<Layout />} />
      <Route
        path="*"
        element={
          <Navigate
            to={
              localStorage.getItem("token") && localStorage.getItem("role")
                ? "/admin/index"
                : "/auth/login"
            }
            replace
          />
        }
      />
    </Routes>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <AppRouter />
    </BrowserRouter>
  );
};

export default App;
